import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=ca57a318&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca57a318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca57a318')) {
      api.createRecord('ca57a318', component.options)
    } else {
      api.reload('ca57a318', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=ca57a318&scoped=true&", function () {
      api.rerender('ca57a318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Automation/Sidebar.vue"
export default component.exports